import { Card } from 'primereact/card';
import type { ReactNode } from 'react';
import styles from './card.module.css';

type Props = { children: ReactNode };

const FormCardContainer = ({ children }: Props) => {
	return <Card className={styles.formCardContainer}>{children}</Card>;
};

export const FormCardContainerWide = ({ children }: Props) => {
	return <Card className={styles.formCardContainerWide}>{children}</Card>;
};

export default FormCardContainer;
